import { format } from "date-fns";
import { Box, Button, Tooltip, Typography, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export interface SmallerHeaderProps {
    entityId: string,
    startDate: Date | null,
    endDate?: Date | null,
    expired?: boolean | null,
    showExpire?: boolean
    onExpire?: (id: string) => void
}

export default function SmallerHeader({ entityId, startDate, endDate, expired = false, onExpire, showExpire }: SmallerHeaderProps) {
    return (
        <Grid container style={{ paddingTop: 16, paddingBottom: 16 }}>
            <Grid size={12}>
                <Box
                    component="div"
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                    <Grid container>
                        <Grid size={9}>
                            <Box component={"div"} style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <Box component={"div"} style={{ marginRight: 32, }}>
                                    <Typography color="secondary" sx={{ fontSize: "14px" }}>
                                        Start Date
                                    </Typography>
                                    <Typography sx={{ fontSize: "18px" }}>
                                        {startDate
                                            ? format(new Date(startDate), "MM/dd/yyyy")
                                            : "n/a"}
                                    </Typography>
                                </Box>
                                <Box component={"div"} style={{ marginRight: 32, }}>
                                    <Typography color="secondary" sx={{ fontSize: "14px" }}>
                                        End Date
                                    </Typography>
                                    <Typography sx={{ fontSize: "18px" }}>
                                        {endDate
                                            ? format(new Date(endDate), "MM/dd/yyyy")
                                            : "n/a"}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        {showExpire ? (
                            <Grid size={3}>
                                <Tooltip title={""}>
                                    <div>
                                        <Button disabled={false}
                                            sx={{ color: expired ? 'primary' : "#8E1C3B" }}
                                            onClick={() => onExpire && onExpire(entityId ?? '')}
                                            startIcon={
                                                expired
                                                    ? (
                                                        <CheckCircleIcon />
                                                    )
                                                    : (

                                                        <CloseIcon
                                                            style={{
                                                                backgroundColor: "#8E1C3B",
                                                                borderRadius: "100%",
                                                                color: "white",
                                                            }}
                                                        />
                                                    )
                                            }
                                        >
                                            {expired ? "Reactivate User" : "Expire User"}
                                        </Button>
                                    </div>
                                </Tooltip>
                            </Grid>

                        ) : (<></>)}

                    </Grid>
                </Box>
            </Grid >
        </Grid >
    );
}